import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ParadigmaModal from "../../../components/ParadigmaModal/ParadigmaModal.js"
import api from "../../../api";

import { Label, Input, FormFeedback } from 'reactstrap';

class Create extends Component {
    constructor(props) {
        super(props);
        this.state = {
        };
    }

    static propTypes = {
        onSubmit: PropTypes.func.isRequired,
    }

    render() {
        return (
            <ParadigmaModal
                postUrl={api.clientes.clasificacion.create}
                onSubmit={() => this.props.onSubmit()}
                successMessage={"El Tipo de Empresa ha sido creado con éxito."}
                title={"Nuevo Tipo de Empresa"}
                buttonTitle={"Nuevo Tipo de Empresa"}
                buttonIcon={"fa fa-plus fa-lg"}
                saveButton={true}
                closeButton={true}
                className={"ui-modal-dialog"}>
                <div className="ui-form">
                    <section className="ui-section-block">
                        <p className="ui-section-label">Datos del tipo</p>
                        <div className="ui-row-1">
                            <div className="ui-field">
                                <Label>Nombre</Label>
                                <Input type="text" name="nombre" autoFocus data-auto-focus="true"></Input>
                                <FormFeedback className="col-12"></FormFeedback>
                            </div>
                        </div>
                    </section>
                </div>
            </ParadigmaModal>
        );
    }
}

export default Create;



// WEBPACK FOOTER //
// ./src/views/clientes/ClasificacionEmpresa/Create.js